var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClientSessionNotesDock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_31557_6501)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 2C8.46499 2 8.69748 2 8.88823 2.05111C9.40587 2.18981 9.81019 2.59413 9.94889 3.11177C10 3.30252 10 3.53501 10 4V8.6C10 9.44008 10 9.86012 9.83651 10.181C9.6927 10.4632 9.46323 10.6927 9.18099 10.8365C8.86012 11 8.44008 11 7.6 11H4.4C3.55992 11 3.13988 11 2.81901 10.8365C2.53677 10.6927 2.3073 10.4632 2.16349 10.181C2 9.86012 2 9.44008 2 8.6V4C2 3.53501 2 3.30252 2.05111 3.11177C2.18981 2.59413 2.59413 2.18981 3.11177 2.05111C3.30252 2 3.53501 2 4 2M4.5 7.5L5.5 8.5L7.75 6.25M4.8 3H7.2C7.48003 3 7.62004 3 7.727 2.9455C7.82108 2.89757 7.89757 2.82108 7.9455 2.727C8 2.62004 8 2.48003 8 2.2V1.8C8 1.51997 8 1.37996 7.9455 1.273C7.89757 1.17892 7.82108 1.10243 7.727 1.0545C7.62004 1 7.48003 1 7.2 1H4.8C4.51997 1 4.37996 1 4.273 1.0545C4.17892 1.10243 4.10243 1.17892 4.0545 1.273C4 1.37996 4 1.51997 4 1.8V2.2C4 2.48003 4 2.62004 4.0545 2.727C4.10243 2.82108 4.17892 2.89757 4.273 2.9455C4.37996 3 4.51997 3 4.8 3Z",
    stroke: "#038A4D",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_31557_6501"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClientSessionNotesDock);
export default __webpack_public_path__ + "static/media/clientSessionNotesDock.0f97b0b9c3de20960cacef0403e99033.svg";
export { ForwardRef as ReactComponent };